<div class="future-wanted-time-picker flex-column flex-center">
  <div class="modal-header">
    <h1 style="margin: 0;">What date do you want your order?</h1>
    <button mat-icon-button (click)="closeModalById('future-wanted-time-modal')">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <span class="alert-message">You are ordering for a future date</span>

  <mat-form-field class="date-dropdown" *ngIf="!isLoading && calendarDateGroup?.length > 0">
    <mat-select placeholder="Select a date" [value]="selectedDate" (selectionChange)="orderDatePicked($event)">
      <mat-option *ngFor="let slot of calendarDateGroup" [value]="slot.calendarDate">
        {{ slot.formattedDate }}
      </mat-option>
    </mat-select>
    <mat-icon matSuffix>calendar_month</mat-icon>
  </mat-form-field>

  <div>
    <h2>What time do you want your order?</h2>

    <ul class="slots-list" *ngIf="!isLoading && timeSlots?.length > 0">
      <li [ngClass]="{ 'selected-item' : selectedTime === slot.time, 'disabled': slot.disabled }"
          id="{{'slot-' + slot.time}}"
          *ngFor="let slot of timeSlots"
          (click)="setSelectedSlot(slot.time, false)">
        <span>{{ slot.title }}</span>
      </li>
    </ul>
  </div>

  <div style="overflow: hidden" *ngIf="isLoading">
    <div class="lds-dual-ring"></div>
  </div>
</div>

<div class="flex-row" style="padding: 4px;">
  <button class="button-action-2" style="flex: 1; margin: 0 2px;" (click)="closeModalById('future-wanted-time-modal')">Cancel</button>
  <button class="button-action-1" style="flex: 1; margin: 0 2px;" (click)="confirmSelection()">OK</button>
</div>
